import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numberFormat' })

export class NumberFormatPipe implements PipeTransform {

  transform(input: any, args?: any): any {
    let exp;
    const suffixes = ['k', 'M', 'B', 'T', 'P', 'E'];

    if (Number.isNaN(input)) {
      return null;
    }

    if (input < 10000) {
      return input?.toFixed(args).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    exp = Math.floor(Math.log(input) / Math.log(1000));

    return (input / Math.pow(1000, exp)).toFixed(args) + suffixes[exp - 1];


  }
}
